<template>
  <ShieldCheck /> 
</template>

<script setup>
import { ShieldCheck } from 'lucide-vue-next';

defineProps({
    size: {
        type: Number,
        default: 14,
    }
  })
</script>
